import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import moment from "moment";

import { useUser, usePopup, useData, useMenu, useLang, usePrompt, useLoading } from "../zustand/store.js";
import { LangText } from "../zustand/dict.js";
import * as APIS from '../utils/service.js'

import consts from '../libs/consts';
import images from "../libs/images"
import InputFileDrag from '../components/InputFileDrag';
import InputSimple from '../components/InputSimple.js';
import Button from '../components/Button';
import Selector from '../components/Selector';
import RadioImage from "../components/RadioImage";
import Radio from "../components/Radio";
import InputRange from "../components/InputRange";
import { getSlideValue, loadImage, toSlideValue } from "../utils/utils.js";
import Modal from "../components/Modal.js";

/**
 * 아바타 만들기
 */
export default function Menu2() {

    const navigate = useNavigate();
    const location = useLocation();

    const { menu, getMenu } = useMenu();
    const { country, getLang } = useLang();
    const { bears, token, options, isReload, reload, setData, addABear } = useUser();
    const { open, title, popOpen, popClose } = usePopup();
    const { setLoading } = useLoading();

    const [config, setConifg] = useState({});
    const [configError, setConfigError] = useState(false);

    const [faceFile, setsfaceFile] = useState(null);
    const [selResolution, setselResolution] = useState(0);  // 해상도 idx
    const [styleIndex, setStyleIndex] = useState(0);
    const [isStyleUpload, setIsStyleUpload] = useState(false); // 아일
    const [styleFile, setStyleFile] = useState(null); // 이미지 스타일 파일obj

    const [prompt, setPrompt] = useState("headshot, portrait");
    const [seed, setSeed] = useState("");
    const [selected, setselected] = useState(1);

    const [photoStr, setphotoStr] = useState(50);
    const [styleStr, setstyleStr] = useState(50);

    const [share, setShare] = useState(false);

    const [moreView, setMoreView] = useState(false)

    const defaultSetOption = (configData) => {
        let error = false

        if ("option_avatar_style" in configData) {
            setStyleIndex(0)
        } else {
            error = true
        }

        if ("option_avatar_resolution" in configData) {
            setselResolution(configData.option_avatar_resolution[0].idx) // 3= 1024x1024
        } else {
            error = true
        }

        if ("option_slide" in configData) {
            setphotoStr(configData.option_slide.photo?.default)
            setstyleStr(configData.option_slide.styleAvarta?.default)
        } else {
            error = true
        }
        if (error) setConfigError(error)

        if (location.state?.artData) {
            setLoading(true)
            setTimeout(() => {
                setLoading(false)
                setLoadFunc(location.state?.artData, configData)
            }, 1000)
        }
    }

    const setLoadFunc = async (artData, configData) => {
        console.log("다시만들기")
        console.log("🚀 ~ setLoadPrec ~ artData:", artData)

        if (artData?.photoFile) {
            let imageData = await loadImage(consts.imgUrl + artData?.photoFile)
            setsfaceFile(imageData)
        }

        if (artData?.imageStyle) {
            let dataIndex = configData?.option_avatar_style?.findIndex(v => v.value == artData?.imageStyle)
            console.log("🚀 ~ setLoadFunc ~ dataIndex:", dataIndex)
            if (dataIndex >= 0) {
                setStyleIndex(dataIndex)
            }
        } else if (artData?.imageStyleFile) {
            setIsStyleUpload(true);
            let imageData = await loadImage(consts.imgUrl + artData?.imageStyleFile)
            setStyleFile(imageData)
        }

        if (artData?.width && artData?.height) {
            let data = configData?.option_avatar_resolution?.find(v => v.title_sub.indexOf(`${artData?.width} x ${artData?.height}`) >= 0)
            if (data) {
                setselResolution(data.idx);
            }
        }

        if (artData?.prompt) {
            setPrompt(artData?.prompt)
        }

        if (artData?.seed) {
            setSeed(artData?.seed)
        }

        if (typeof artData?.photoStrength == "number") {
            setphotoStr(artData?.photoStrength)
        }

        if (typeof artData?.styleStrength == "number") {
            setstyleStr(artData?.styleStrength)
        }
    }

    // 아바타 만들기
    const makeImageFunc = () => {
        console.log("makeImageFunc!!")
        if (configError) {
            setModal({
                ...modal,
                open: true,
                message: <>
                    <p style={{ textAlign: "center" }}>load config error</p>
                    <p style={{ textAlign: "center" }}>please retry.</p>
                </>
            })
            return;
        }

        let sendData = {
            photo: "",
            imageStyle: 0,
            resolution: null,
            photoStrength: 0.5,
            styleStrength: 1,
            prompt: "",
            seed: seed,
            share: !share,
        }

        if (!faceFile) {
            setModal({
                ...modal,
                open: true,
                message: getLang({ key: "error_input_photo" })
            })
            return;
        }

        sendData.photo = faceFile; // 사진 설정
        if (isStyleUpload) { //스타일 설정
            if (!styleFile) {
                setModal({
                    ...modal,
                    open: true,
                    message: getLang({ key: "error_input_style" })
                })
                return;
            }
            sendData.imageStyle = styleFile
        } else {
            sendData.imageStyle = config.option_avatar_style[styleIndex].idx
        }
        // 해상도 설정
        sendData.resolution = selResolution;
        if (prompt) {
            sendData.prompt = prompt;
        }

        // 시드값 설정
        if (seed) {
            sendData.seed = seed
        }

        // 사진 , 스타일 반영정도 설정
        sendData.photoStrength = Number(photoStr)
        sendData.styleStrength = Number(styleStr)

        console.log("🚀 ~ makeImageFunc ~ sendData:", sendData)
        setLoading(true);
        // setTimeout(() => {
        //     setLoading(false);
        // }, 1500)

        APIS.post("/aiImage/avatar", sendData).then(({ data }) => {
            if (data) console.log("/aiImage/avatar:", data);
            setLoading(false);
            reload();
            navigate("/myart_history")
        }).catch((result) => {
            setLoading(false);
            let data = result.response.data;
            console.log(data, getLang({ key: data.msgkey }));
            setModal({
                ...modal,
                open: true,
                message: getLang({ key: data.msgkey })
            })
        })
    }

    const configDataFunc = () => {
        APIS.post('/config/option').then(({ data }) => {
            setConifg(data);
            defaultSetOption(data);
        }).catch((e) => {
            console.log(e.response.data);
        });
    }

    useEffect(() => {
        configDataFunc();
    }, [])

    const [modal, setModal] = useState(consts.defaultModalValue)

    const modalConfirm = () => {
        if (modal.type === "test") {

        } else {
            modalClose();
        }
    }

    const modalClose = () => {
        setModal(consts.defaultModalValue)
    }

    return (
        <>
            <Modal
                open={modal.open}
                setOpen={(v) => {
                    setModal({ ...modal, open: v })
                }}
                title={modal.title}
                message={modal.message}
                onConfirm={modalConfirm}
                onCancel={modal.isClose ? () => { modalClose(); } : null}
            />

            <div className="content">
                <div className="title_box3">
                    <div className="text_area">
                        <p className="title">
                            <LangText id={getMenu({ idx: 2 })?.title_key} />
                        </p>
                        <p className="sub_title">
                            <LangText id={getMenu({ idx: 2 })?.info_key} />
                        </p>
                    </div>
                    <div className="thumb">
                        <img src={consts.imgUrl + getMenu({ idx: 2 })?.image?.[country]} />
                    </div>
                </div>

                <div className="setting_box">
                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_upload_face" /></p>
                                <p className="body1"><LangText id="info_upload_face" /></p>
                            </div>
                        </div>

                        <InputFileDrag
                            name="drag-file"
                            value={faceFile}
                            setValue={setsfaceFile}
                        />
                    </div>

                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_set_image_style" /></p>
                                <p className="body1"><LangText id="info_image_style" /></p>
                            </div>

                            <Button title={isStyleUpload ? getLang({ key: "btn_show_style" }) : getLang({ key: "btn_upload_image_style" })} type={2} onClick={() => {
                                setIsStyleUpload(!isStyleUpload)
                            }} />
                        </div>
                        {!isStyleUpload ? <div className="border_box">
                            <p className="body1"><LangText id="text_style_list" /></p>
                            <RadioImage
                                className="mt-12"
                                // options={[
                                //     { title: "스타일옵션#1", imgSrc: images.block_img },
                                // ]}
                                options={config?.option_avatar_style?.map((v) => {
                                    return { title: getLang({ key: v?.title_key }), imgSrc: `${consts.imgUrl}${v?.imgPath}` }
                                })}
                                current={styleIndex}
                                onChange={setStyleIndex}
                            />
                        </div> : <InputFileDrag
                            name="drag-file-style"
                            value={styleFile}
                            setValue={setStyleFile}
                        />}

                    </div>

                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_image_resolution" /></p>
                                <p className="body1"><LangText id="info_image_resolution" /></p>
                            </div>
                        </div>

                        <div
                            style={{ display: "flex", minWidth: 210 }}
                            className="sel_box">
                            <Selector
                                placeholder={getLang({ key: "text_select" })}
                                options={config?.option_avatar_resolution?.map(v => {
                                    // return { value: v?.idx, label: `${getLang({ key: v?.title_key })} ${v?.title_sub}` }
                                    return { value: v?.idx, label: <><LangText id={v?.title_key} /> {v?.title_sub}</> }
                                })}
                                value={selResolution}
                                setValue={setselResolution}
                            />
                        </div>
                    </div>

                    {/* ------------------- more section ---------------------- */}

                    {moreView && <>
                        <div className="option_item_box">
                            <div className="menu_title_box">
                                <div className="text_box">
                                    <p className="title2"><LangText id="text_prompt_set" /></p>
                                    <p className="body1"><LangText id="info_image_prompt" /></p>
                                </div>
                            </div>

                            <InputSimple
                                style
                                value={prompt}
                                setValue={setPrompt}
                                placeholder={getLang({ key: "placeholder_seed" })}
                            />
                        </div>

                        <div className="option_item_box">
                            <div className="menu_title_box">
                                <div className="text_box">
                                    <p className="title2"><LangText id="text_set_seed" /></p>
                                    <p className="body1">
                                        <LangText id="info_set_seed1" />
                                        <span className="color-sec"><LangText id="info_set_seed2" /></span>
                                    </p>
                                </div>
                            </div>

                            <InputSimple
                                style
                                valid="num"
                                value={seed}
                                setValue={setSeed}
                                placeholder={getLang({ key: "placeholder_seed" })}
                            />
                        </div>

                        {/* <div className="option_item_box">
                            <div className="menu_title_box">
                                <div className="text_box">
                                    <p className="title2"><LangText id="text_prompt_strength" /></p>
                                    <p className="body1">
                                        <LangText id="info_prompt_strength" />
                                    </p>
                                </div>
                            </div>

                            <InputRange
                                startText={getLang({ key: "text_ai_art" })}
                                endText={getLang({ key: "text_prompt" })}
                                value={promtStr}
                                setValue={setpromtStr}
                            />
                        </div> */}

                        {/* <div className="option_item_box">
                            <div className="menu_title_box">
                                <div className="text_box">
                                    <p className="title2"><LangText id="text_negative_propmt" /></p>
                                    <p className="body1">
                                        <LangText id="info_negative_propmt" />
                                    </p>
                                </div>
                            </div>

                            <InputSimple
                                style
                                valid="num"
                                value={""}
                                setValue={() => { }}
                                placeholder={getLang({ key: "info_negative_propmt" })}
                            />
                        </div> */}

                        <div className="option_item_box">
                            <div className="menu_title_box">
                                <div className="text_box">
                                    <p className="title2"><LangText id="text_face_ref_set" /></p>
                                    <p className="body1">
                                        <LangText id="info_face_ref_set" />
                                    </p>
                                </div>
                            </div>

                            <InputRange
                                className="mt-24"
                                startText={getLang({ key: "text_ai_art" })}
                                endText={getLang({ key: "option_selector_contents5" })}
                                step={config.option_slide?.photo?.step}
                                min={config.option_slide?.photo?.min || 0}
                                max={config.option_slide?.photo?.max || 100}
                                value={photoStr}
                                setValue={setphotoStr}
                                tickerValue={photoStr}
                            />
                        </div>

                        <div className="option_item_box">
                            <div className="menu_title_box">
                                <div className="text_box">
                                    <p className="title2"><LangText id="text_style_ref_set" /></p>
                                    <p className="body1">
                                        <LangText id="info_style_ref_set" />
                                    </p>
                                </div>
                            </div>

                            <InputRange
                                className="mt-24"
                                startText={getLang({ key: "text_str_min" })}
                                endText={getLang({ key: "text_str_max" })}
                                step={config.option_slide?.styleAvarta?.step}
                                min={config.option_slide?.styleAvarta?.min || 0}
                                max={config.option_slide?.styleAvarta?.max || 100}
                                value={styleStr}
                                setValue={setstyleStr}
                                tickerValue={styleStr}
                            />
                        </div>
                    </>}


                    {/* ------------------- more section ---------------------- */}

                    <div className="more_box" >
                        <div className="btn_box"
                            onClick={() => {
                                setMoreView(!moreView)
                            }}>
                            <p className={`title${moreView ? " focus" : ""}`}>
                                <LangText id="text_more_option" />
                            </p>
                        </div>
                    </div>
                </div>

                <div className="confirm_box mt-80">
                    <Button
                        type={4}
                        title={getLang({ key: "btn_create_image", replace: { key: "{0}", val: getMenu({ idx: 2 })?.point } })}
                        round
                        onClick={makeImageFunc}
                    />
                    <input
                        type="checkbox"
                        id={"checkShare"}
                        className='checkbox5'
                        // checked={false}
                        checked={share}
                        onChange={(e) => {
                            setShare(e.target.checked)
                        }} />
                    <label className="mt-12" for={'checkShare'}>
                        <LangText id="btn_not_share" />
                    </label>
                </div>
            </div>
        </>
    );
}
